module.exports = __webpack_public_path__ + "img/img111.12823226.svg";